import { ChatRouteCardContent } from "../../types/chat/ChatContent";

import { parseRouteStops } from "./parseManageRouteStopsAction";

// Unlike a proposal's snapshot, an empty stop list is a valid card: the route exists, it just has
// nothing on it yet.
const parseRouteCard = (payload: Record<string, unknown>): ChatRouteCardContent | undefined => {
  if (typeof payload.routeId !== "number" || typeof payload.name !== "string") {
    return undefined;
  }
  const route = parseRouteStops(payload);
  return route ? { ...route, name: payload.name, routeId: payload.routeId } : undefined;
};

export default parseRouteCard;
